<template>
    <div>
        <div class="text-center">
            This integration is active.
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data() {
            return {
                isDeactivating: false
            }
        },
        props: {
            integration: {
                type: Object,
                required: true
            }
        },
        methods: {
            ...mapActions([
                'requestIntegrationDeactivationViaEmail'
            ]),
            clickDeactivate() {
                this.isDeactivating = true;

                this.requestIntegrationDeactivationViaEmail(this.integration).then(response => {
                    this.isDeactivating = false;
                    this.$emit('close');
                }).catch(err => {
                    this.isDeactivating = false;
                })
            }
        }
    }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// activated.vue?255a319a